export default __webpack_public_path__ + "static/media/data_not_found.72948394.svg";